import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const paper: SxStyle = {
  background: (p) => p.palette.background.neutral,
  p: 2,
};

export const item: SxStyleFunc<boolean | undefined> = (isDragging) => ({
  flex: 1,
  opacity: isDragging ? 0.5 : 1,
});

export const titleContainer: SxStyle = {
  width: '100%',
};
